import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'components/ProtectedRoute';

const DynamoScreen = React.lazy(() => import('./screens/DynamoScreen'));

const routes = [
  '/',
  '/:params',
  '/olm-login',
  '/olm-authorization',
  '/olm-linking',
  '/olm-success',
  '/olm-fail',
  '/olm-confirm'
];

const App = () => {
  // if (process.env.REACT_APP_ENV === 'production') {
  //   console.log = function() {}
  // }
  return (
    <BrowserRouter
      basename="/olm"
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true
      }}
    >
      <Suspense fallback={<></>}>
        <Routes>
          {routes.map((route) => {
            if (route.includes('params')) {
              return (
                <Route path="/:params" key={route} element={<DynamoScreen />} />
              );
            } else {
              return (
                <Route
                  path={route}
                  key={route}
                  element={<ProtectedRoute element={<DynamoScreen />} />}
                />
              );
            }
          })}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
